// Complete Employee Form Fields Configuration with Steps
export const employeeFormSteps = [
  {
    stepNumber: 1,
    stepLabel: "Personal Information",
    fields: [
      "firstName",
      "surname",
      "lastName",
      "idNumber",
      "genderId",
      "dob",
    ]
  },
  {
    stepNumber: 2,
    stepLabel: "Contact Information",
    fields: [
      "mobileNumber",
      "emailAddress",
      "regionId",
      "branchId"
    ]
  },
  {
    stepNumber: 3,
    stepLabel: "Employment Details",
    fields: [
      "deptId",
      "jobTitle",
      //"salaryBandId",
      "hireDate",
      "terminationDate",
     // "baseSalary"
    ]
  },

  {
    stepNumber: 4,
    stepLabel: "Statutory Information",
    fields: [
      "kraPin",
      "nssfNo",
      "shifNo",
      "helbNo"
    ]
  },
  {
    stepNumber: 5,
    stepLabel: "Bank Details",
    fields: [
      "bankId",
      "bankBranchId",
      "accountNumber"
    ]
  },
  {
    stepNumber: 6,
    stepLabel: "Next of Kin",
    fields: [
      "nokFirstName",
      "nokLastName",
      "nokRelationShip",
      "nokPhone",
      "userId"
    ]
  }
];
 
export const employeeFormFields = [
  // Step 1
  { name: "firstName", label: "First Name", type: "text", gridColumn: "span 2", required: true },
  { name: "surname", label: "Surname", type: "text", gridColumn: "span 2", required: true },
  { name: "lastName", label: "Last Name", type: "text", gridColumn: "span 2", required: false },
  { name: "idNumber", label: "ID Number", type: "text", gridColumn: "span 2", required: true },
  { name: "genderId", label: "Gender", type: "select", options: [], gridColumn: "span 2", required: true },
  { name: "dob", label: "Date of Birth", type: "date", gridColumn: "span 2", required: true },

  // Step 2
  { name: "mobileNumber", label: "Mobile Number", type: "text", gridColumn: "span 2", required: true },
  { name: "emailAddress", label: "Email Address", type: "email", gridColumn: "span 2", required: true },
  { name: "regionId", label: "Region", type: "select", options: [], gridColumn: "span 2", required: false,parent: "main" },
  { name: "branchId", label: "Branch", type: "select", options: [], gridColumn: "span 2", required: false, dependentOn: "regionId",parent: "dependent" },

  // Step 3
  { name: "deptId", label: "Department", type: "select", options: [], gridColumn: "span 2", required: true },
  { name: "jobTitle", label: "Job Title", type: "text", gridColumn: "span 2", required: true },
 // { name: "salaryBandId", label: "Salary Band", type: "select", options: [], gridColumn: "span 2", required: false },
  { name: "hireDate", label: "Hire Date", type: "date", gridColumn: "span 2", required: true },
  { name: "terminationDate", label: "Termination Date", type: "date", gridColumn: "span 2", required: false },
  // { name: "baseSalary", label: "Base Salary", type: "number", gridColumn: "span 2", required: false },

  // Step 4
 

  // Step 5
  { name: "kraPin", label: "KRA PIN", type: "text", gridColumn: "span 2", required: true },
  { name: "nssfNo", label: "NSSF No", type: "text", gridColumn: "span 2", required: false },
  { name: "shifNo", label: "SHIF No", type: "text", gridColumn: "span 2", required: false },
  { name: "helbNo", label: "HELB No", type: "text", gridColumn: "span 2", required: false },

  // Step 6
  { name: "bankId", label: "Bank", type: "select", options: [], gridColumn: "span 2", required: false,parent: "main" },
  { name: "bankBranchId", label: "Bank Branch", type: "select", options: [], gridColumn: "span 2", required: false, dependentOn: "bankId" ,parent: "dependent"},
  { name: "accountNumber", label: "Account Number", type: "text", gridColumn: "span 2", required: false },

  // Step 7
  { name: "nokFirstName", label: "NOK First Name", type: "text", gridColumn: "span 2", required: false },
  { name: "nokLastName", label: "NOK Last Name", type: "text", gridColumn: "span 2", required: false },
  { name: "nokRelationShip", label: "Relationship", type: "select", options: [], gridColumn: "span 2", required: false },
  { name: "nokPhone", label: "NOK Phone", type: "text", gridColumn: "span 2", required: false },
  {
  name: "userId",
  label: "Associated System User",
  type: "select",
  options: [], // populated dynamically
  gridColumn: "span 2",
  required: false,
  helperText: "Optional: Link to a user account in the system",
},
];